import { IBatchPromiseElement, IBatchOptions } from '../models/api/common';

export async function batchExecutePromises(batchPromiseElements: IBatchPromiseElement[], passedOptions: IBatchOptions = {}) {
	const options = Object.assign({}, { maxBatchSize: 100 }, passedOptions);
	const elements: IBatchPromiseElement[] = [].concat(batchPromiseElements);
	const { maxBatchSize } = options;

	while (elements.length > 0) {
		const currentBatchSize = Math.min(elements.length, maxBatchSize);
		const currentBatch = elements.splice(0, currentBatchSize);
		const promises = currentBatch.map((element) => {
			return element.promiseFunc();
		});
		const responses = await Promise.all(promises);
		for (let i = 0; i < responses.length; i++) {
			const response = responses[i];
			const element = currentBatch[i];
			await element.responseFunc(response, element.identifier);
		}
	}
}